export default {
  blade: undefined,
  download: true,
  report: undefined
}
